// PROMPT 3.2 — /build-my-loadout dedicated page.
// The two quiz entry points (Surface A + Surface B) route here.
// Reuses the QuizModal component's flow embedded as a full-viewport panel.

import { useEffect, useState } from "react";
import { useSeoMeta } from "../lib/seo";
import { useNavigate } from "react-router-dom";
import TopUtilityBar from "../sections/TopUtilityBar";
import MainHeader from "../sections/MainHeader";
import Footer from "../sections/Footer";
import QuizModal from "../sections/QuizModal";

// Page literal title — allowed hit for T20 substring audit.
export const PAGE_TITLE = "Build My Loadout";

export default function BuildMyLoadout() {
        const navigate = useNavigate();
        const [open, setOpen] = useState(true);

        useSeoMeta({
                title: `${PAGE_TITLE} — Loadout`,
                description: "Answer a few questions about your games, grip and hand size and get a matched gaming mouse, keyboard and mousepad loadout from Loadout India.",
                path: "/build-my-loadout",
        });

        const handleClose = () => {
                setOpen(false);
                // Return to homepage after a small delay for the close transition.
                setTimeout(() => navigate("/"), 200);
        };

        return (
                <div className="min-h-screen bg-white text-[#0A0A0A]">
                        <TopUtilityBar />
                        <MainHeader cartCount={0} />
                        <main
                                data-testid="build-my-loadout-page"
                                className="mx-auto max-w-[1440px] px-6 py-12 md:py-16"
                        >
                                <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-[#FF9F1C]">
                                        Configurator
                                </p>
                                <h1 className="mt-3 font-display text-[36px] md:text-[56px] leading-[0.95] uppercase">
                                        {PAGE_TITLE}
                                </h1>
                                <p className="mt-4 font-sans text-[15px] md:text-[16px] text-[#4A4A4A] max-w-[640px] leading-relaxed">
                                        Answer four short prompts. We'll rank Loadout SKUs against your
                                        picks and show what fits your budget.
                                </p>
                        </main>
                        <QuizModal open={open} onClose={handleClose} />
                        <Footer />
                </div>
        );
}
